// @flow

import {fromJS, Map} from 'immutable';
import {
  RECEIVE_VIDEO_DETAILS,
  REQUEST_VIDEO_DETAILS,
  RECEIVE_MEDIA_OEMBED,
} from './actions';

type StateType = Map<string, Map<string, mixed>>;

const defaultState: StateType = Map({
  isFetching: Map({}),
  videos: Map({}),
  oEmbeds: Map({}),
});

const videosArea = (
  state: StateType = defaultState,
  action: any
): StateType => {
  switch (action.type) {
    case REQUEST_VIDEO_DETAILS:
      return state.setIn(['isFetching', action.hashid], true);

    case RECEIVE_VIDEO_DETAILS: {
      const video = action.video;
      state.setIn(['isFetching', video.hashid], false);
      return state.setIn(['videos', video.hashid], fromJS(video));
    }
    case RECEIVE_MEDIA_OEMBED:
      return state.setIn(['oEmbeds', action.url], action.oembed);

    default:
      return state;
  }
};

export default videosArea;
